






















































import ItemCard from '@/components/card/ItemCard.vue'
import ListItem from '@/components/list/ListItem.vue'
import BankImg from '@/components/image/BankImg.vue'
import toCurrency from '@/filters/to-currency'
import toInvoiceStatusColor from '@/filters/to-invoice-status-color'
import toInvoiceTextColor from '@/filters/to-invoice-status-text-color'
import toDate from '@/filters/to-date'
import Translation from '@/mixins/Translation'
import Assets from '@/mixins/Assets'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import {InvoiceStatus} from '@/store/modules/invoices/types'

@Component({
  filters: {
    toCurrency,
  },
  components: {
    ItemCard,
    ListItem,
    BankImg,
  },
})
export default class InvoiceCard extends Mixins(Translation, Assets) {
  @Prop() empty: boolean
  @Prop() amount: number
  @Prop() tradedAt: number
  @Prop() paidAt: number
  @Prop() id: string
  @Prop() status: InvoiceStatus
  @Prop() mainItemName: string
  @Prop() clientName: string
  @Prop() clientRepresentativeName: string
  @Prop() clientBizRegistrationNumber: string
  @Prop() clientId: string
  @Prop({default: 'KRW'}) currency: string
  @Prop({default: false, type: Boolean}) loading: boolean
  @Prop({default: false, type: Boolean}) disabled: boolean
  @Prop({default: false, type: Boolean}) isSelectMode: boolean
  @Prop({default: false}) hasClientBankAccount: boolean
  @Prop({default: false}) clientBankAccount: any

  get outline() {
    const {status} = this
    if(status === 'none-cert') {
      return 'danger-light'
    } else if(status === 'processing-cert') {
      return 'warning'
    }
    return ''
  }

  get actions() {
    const {status} = this
    if(status === 'none-cert') {
      return [{
        title: this.ts('certificate-register'),
        color: 'primary',
      }]
    } else if(status === 'processing-cert') {
      return null
    }
    return [
      {
        title: toDate(this.tradedAt),
        color: 'gray-600',
        size: 'mini',
      },
      {
        title: toCurrency(this.amount) + this.ts(this.currency),
        color: status === 'unavailable' ? 'danger-light-2' : 'gray-800'
      }
    ]
  }

  get invoiceCardTitle() {
    return this.clientName || this.clientRepresentativeName ||this.clientBizRegistrationNumber || ' '
  }

  get bankTitle() {
    const {ts, clientBankAccount} = this
    const code = clientBankAccount.bank
    const owner = clientBankAccount.ownerName || clientBankAccount.owner
    return `${ts(`bank-codes.${code}`)} ${clientBankAccount.number} ${owner}`
  }

  get tags() {
    const {status} = this
    return [{
      name: this.ts(`status.${status}`),
      color: toInvoiceStatusColor(status),
      textColor: toInvoiceTextColor(status),
    }]
  }

  onClickEditBankAccount() {
    this.$emit('open-edit-account')
  }
}
